import React, { useState } from 'react';
import CollapsiblePanel from '../../../../formInputsV2/CollapsiblePanel';
import { safeCapitalizeWords } from '../../../../constants';
import { Card, AlwaysOpenAtDesktop } from './shared.styles';
import { ModificaButton } from './VehicleSummaryCard.styles';
import {
  EmptyState,
  TotalBar,
  TotalLabel,
  TotalAmount,
  EstimatedCommission,
  TotalActions,
  ProcediCta,
  QuoteList,
  QuoteLineItem,
  CompanyName,
  QuoteTypeTag,
  Amount,
} from './QuoteCostSummaryCard.styles';

function QuoteCostSummaryCard({
  processingQuote,
  quoteTypes,
  riskQuotations,
  primaQuoteTypes,
  getTotal,
  onProcedi,
  // Most products key the top line's tag off quoteTypes via quote_type.
  // Ancillari Auto/Salute/Casa's processingQuote isn't one of the standard
  // quoteTypes (it carries its own product_name instead) — callers for
  // whom that lookup doesn't apply pass the label directly here.
  rcTypeLabel,
  // Product 11 = Casa (see getProductNameForUrl in common/constants) — the
  // only product with a second action next to Procedi. Gated on the id
  // itself, not just prop presence, so this stays Casa-only even if another
  // screen ever passes onModifyGuarantees by mistake.
  productId,
  onModifyGuarantees,
  est_provvigioni,
}) {
  const [detailsOpen, setDetailsOpen] = useState(false);

  if (processingQuote === null) {
    return (
      <Card>
        <EmptyState>Seleziona Le Quotazioni Che Vuoi Aquistare</EmptyState>
      </Card>
    );
  }

  const companyName = processingQuote.company !== null
    ? processingQuote.company.name
    : processingQuote.preventivas_company.company_name;

  const rcTypeName = safeCapitalizeWords(rcTypeLabel ?? quoteTypes.find(
    (item) => item.id === processingQuote.quote_type,
  ).name);

  return (
    <Card>
      <TotalBar>
        <div>
          <TotalLabel>Totale</TotalLabel>
          <TotalAmount>
            {getTotal()}
            {' '}
            €
          </TotalAmount>
          {(est_provvigioni != null && est_provvigioni !== '' && !Number.isNaN(parseFloat(est_provvigioni))) && (
            <EstimatedCommission>
              Stima Provvigioni:
              {' '}
              {parseFloat(est_provvigioni).toFixed(2)}
              {' '}
              €
            </EstimatedCommission>
          )}
        </div>
        <TotalActions>
          {Number(productId) === 11 && onModifyGuarantees && (
            <ModificaButton type="button" onClick={onModifyGuarantees}>
              Modifica Garanzie
            </ModificaButton>
          )}
          {onProcedi && (
            <ProcediCta type="button" onClick={onProcedi}>
              Procedi
            </ProcediCta>
          )}
        </TotalActions>
      </TotalBar>

      <AlwaysOpenAtDesktop>
        <CollapsiblePanel
          open={detailsOpen}
          onToggle={() => setDetailsOpen((open) => !open)}
          instructionText=""
          openLabel="Nascondi Dettaglio"
          closedLabel="Vedi Dettaglio Quotazioni"
        >
          <QuoteList>
            <QuoteLineItem>
              <CompanyName>
                {companyName}
                {' '}
                <QuoteTypeTag>
                  (
                  {rcTypeName}
                  )
                </QuoteTypeTag>
              </CompanyName>
              <Amount>
                {parseFloat(processingQuote.amount ? processingQuote.amount : 0).toFixed(2)}
                {' '}
                €
              </Amount>
            </QuoteLineItem>

            {quoteTypes
              .filter((t) => t.id !== 'res_civile')
              .map((type) => (
                <React.Fragment key={type.id}>
                  {riskQuotations && riskQuotations[type.id]
                    ? riskQuotations[type.id].map((quote, i) => (
                      <QuoteLineItem key={i}>
                        <CompanyName>
                          {quote.company !== null
                            ? quote.company.name
                            : quote.preventivas_company.company_name}
                          {' '}

                          <QuoteTypeTag>
                            (
                            {
                              safeCapitalizeWords(quoteTypes.find(
                                (item) => item.id === quote.quote_type,
                              ).name)
                            }
                            )
                          </QuoteTypeTag>
                        </CompanyName>
                        <Amount>
                          {parseFloat(quote.amount).toFixed(2)}
                          {' '}
                          €
                        </Amount>
                      </QuoteLineItem>
                    ))
                    : null}
                </React.Fragment>
              ))}

            {processingQuote.company_id === 2
              && processingQuote.guarantees.map((guarantee, index) => (
                <QuoteLineItem key={index}>
                  <CompanyName>
                    Prima.it
                    {' '}
                    <QuoteTypeTag>
                      (
                      {
                        safeCapitalizeWords(primaQuoteTypes.find(
                          (type) => type.id === guarantee.guarantees_slug,
                        ).name)
                      }
                      )
                    </QuoteTypeTag>
                  </CompanyName>
                  <Amount>
                    {parseFloat(guarantee.amount).toFixed(2)}
                    {' '}
                    €
                  </Amount>
                </QuoteLineItem>
              ))}
          </QuoteList>
        </CollapsiblePanel>
      </AlwaysOpenAtDesktop>
    </Card>
  );
}

export default QuoteCostSummaryCard;
